import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Loader2, ArrowLeft } from 'lucide-react';

const SignupPage = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { signup } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        const result = await signup(name, email);

        if (!result.success) {
            setError(result.error);
        }
        setLoading(false);
    };

    return (
        <div className="min-h-screen mafia-gradient flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                {/* Logo */}
                <div className="text-center mb-8 animate-fade-in">
                    <h1 className="font-display text-5xl font-bold gold-text mb-2">Don Doit</h1>
                    <p className="text-muted-foreground text-lg">Il Timesheet della Famiglia 🤌🇫🇷</p>
                    <p className="text-muted-foreground/60 text-xs mt-1 italic">"Don't do it? No no, DO IT!"</p>
                </div>

                <Card className="card-mafia animate-fade-in" style={{ animationDelay: '0.2s' }}>
                    <CardHeader className="text-center">
                        <CardTitle className="font-display text-2xl gold-text">Unisciti alla Famiglia</CardTitle>
                        <CardDescription>Diventa un membro della Famiglia QuiteBold</CardDescription>
                    </CardHeader>
                    <CardContent>
                        <form onSubmit={handleSubmit} className="space-y-4">
                            <div>
                                <Input
                                    type="text"
                                    placeholder="Il tuo nome..."
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    className="input-mafia h-12"
                                    data-testid="name-input"
                                    required
                                />
                            </div>

                            <div>
                                <Input
                                    type="email"
                                    placeholder="La tua email..."
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="input-mafia h-12"
                                    data-testid="email-input"
                                    required
                                />
                            </div>

                            {error && (
                                <Alert variant="destructive" className="bg-destructive/10 border-destructive/30">
                                    <AlertDescription>{error}</AlertDescription>
                                </Alert>
                            )}

                            <Button
                                type="submit"
                                className="w-full btn-gold h-12 text-lg font-semibold"
                                disabled={loading || !email || !name}
                                data-testid="signup-button"
                            >
                                {loading ? (
                                    <><Loader2 className="w-5 h-5 mr-2 animate-spin" /> Registrando...</>
                                ) : (
                                    'Unisciti Ora'
                                )}
                            </Button>
                        </form>

                        {/* Link to login */}
                        <div className="mt-6 pt-6 border-t border-border text-center">
                            <p className="text-sm text-muted-foreground mb-3">
                                Sei già un membro della Famiglia?
                            </p>
                            <Link
                                to="/login"
                                className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full"
                            >
                                <ArrowLeft className="w-4 h-4 mr-2" />
                                Torna al Login
                            </Link>
                        </div>
                    </CardContent>
                </Card>

                {/* Footer */}
                <p className="text-center text-muted-foreground text-xs mt-6 animate-fade-in" style={{ animationDelay: '0.4s' }}>
                    La Famiglia QuiteBold © 2025
                </p>
            </div>
        </div>
    );
};

export default SignupPage;
